"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAuctionHistory = exports.fetchAuctionBidByWalletAddress = exports.fetchAuctionsByShopAddress = void 0;
const backend_1 = require("./factory/backend");
const config_1 = __importDefault(require("./vendor/config"));
function fetchAuctionsByShopAddress(shopId, queryDto) {
    return (0, backend_1.fetchAuctionsByShop)(config_1.default, shopId, queryDto);
}
exports.fetchAuctionsByShopAddress = fetchAuctionsByShopAddress;
function fetchAuctionBidByWalletAddress(auctionAddress, walletAddress) {
    return (0, backend_1.fetchAuctionBid)(config_1.default, auctionAddress, walletAddress);
}
exports.fetchAuctionBidByWalletAddress = fetchAuctionBidByWalletAddress;
function fetchAuctionHistory(auctionAddress, auctionBidQuery) {
    return (0, backend_1.fetchAuctionHistoryByAddress)(config_1.default, auctionAddress, auctionBidQuery);
}
exports.fetchAuctionHistory = fetchAuctionHistory;
